import request from '../utils/request';

// 业务指南相关接口
export interface BusinessItem {
  id?: number;
  parentId?: number;
  type: string;
  name: string;
  description?: string;
  icon?: string;
  orderNum?: number;
  status?: string;
  isHighlighted?: string;
  level?: number;
  content?: string;
  contentType?: string;
  stepOrder?: number;
  isRequired?: number;
  estimatedTime?: string;
  requiredMaterials?: string;
  processNotes?: string;
  relatedLinks?: string;
  createTime?: string;
  createUser?: string;
  updateTime?: string;
  updateUser?: string;
  deleted?: number;
  remark?: string;
  children?: BusinessItem[];
}

export interface BusinessListParams {
  current?: number;
  size?: number;
  keyword?: string;
  category?: string;
  status?: string;
}

export interface BusinessListResponse {
  records: BusinessItem[];
  total: number;
  size: number;
  current: number;
  pages: number;
}

// 业务指南API
export const businessApi = {
  // 分页查询业务指南列表
  getList: (params: BusinessListParams) => 
    request<BusinessListResponse>({
      url: '/api/biz/business/list',
      method: 'GET',
      params,
    }),

  // 根据ID查询业务指南
  getById: (id: number) =>
    request<BusinessItem>({
      url: `/api/biz/business/${id}`,
      method: 'GET',
    }),

  // 根据类型查询业务指南
  getByType: (type: string) =>
    request<BusinessItem[]>({
      url: `/api/biz/business/type/${type}`,
      method: 'GET',
    }),

  // 根据父级ID查询子级列表
  getChildren: (parentId: number) =>
    request<BusinessItem[]>({
      url: `/api/biz/business/children/${parentId}`,
      method: 'GET',
    }),

  // 新增业务指南
  create: (data: BusinessItem) =>
    request<string>({
      url: '/api/biz/business',
      method: 'POST',
      data,
    }),

  // 修改业务指南
  update: (data: BusinessItem) =>
    request<string>({
      url: '/api/biz/business',
      method: 'PUT',
      data,
    }),

  // 删除业务指南
  delete: (id: number) =>
    request<string>({
      url: `/api/biz/business/${id}`,
      method: 'DELETE',
    }),

  // 批量删除业务指南
  batchDelete: (ids: number[]) =>
    request<string>({
      url: '/api/biz/business/batch',
      method: 'DELETE',
      data: ids,
    }),

  // 获取所有业务指南数据（用于树形展示）
  getAll: (params: BusinessListParams) =>
    request<BusinessItem[]>({
      url: '/api/biz/business/all',
      method: 'GET',
      params,
    }),

  // 获取级联字典数据
  getCascadeDict: (parentValue?: string, dictType?: string) =>
    request<Array<{ dict_value: string; dict_label: string }>>({
      url: '/api/biz/business/cascade-dict',
      method: 'GET',
      params: { parentValue, dictType },
    }),
};
